import React from 'react';

export const ExamSafeMarkdownArea = React.lazy(() => import('./ExamSafeMarkdownArea'));
